if (!customElements.get('read-more-section')) {
  class ReadMore extends HTMLElement {
    constructor() {
      super();

      this.contentText = this.querySelector('.collection-text');
      this.readMore = this.querySelector('.button-read-more');
      this.initialRange = this.dataset.initialRange || 3;

      if (!this.readMore || !this.contentText) return;

      if (this.contentText.children.length > this.initialRange) {
        const hiddenChildren = Array.from(this.contentText.children).slice(this.initialRange);

        hiddenChildren.forEach((child) => child.classList.remove('active'));

        this.readMore.addEventListener('click', () => {
          hiddenChildren.forEach((child) => child.classList.toggle('active'));

          this.contentText.classList.toggle('active');
          if (this.contentText.classList.contains('active')) {
            this.readMore.textContent = 'Read Less';
          } else {
            this.readMore.textContent = 'Read More';
          }
        });
      } else {
        this.readMore.style.display = 'none';
      }
    }
  }

  customElements.define('read-more-section', ReadMore);
}
